<template>
    <div v-if="showApp">
        <page-documentation></page-documentation>
    </div>
</template>

<script>

import PageDocumentation from "@/projects/documentation/components/page-home.vue";

export default {
    data() {
        return {
            showApp: false,
        };
    },
    mounted() {
        let appsToShow = this.$store.state.webApplicationToShow;
        let currentApp = this.$route.fullPath.replace("/", "").split('?')[0];
        if (appsToShow.includes(currentApp)) this.showApp = true;
    },
    components: {
        PageDocumentation,
    },
};
</script>

<style></style>
